module.exports = __webpack_public_path__ + "img/93308elbaul.0d5a873a.jpg";